import React, { useContext, useState, useMemo } from 'react';
import { Grid } from '@material-ui/core';
import styles from './ProductView.module.css';
import { getProductImageSrc } from '../../../helpers/ProductHelper';
import { CartContext } from '../../../contexts/CartContext';
import { ShopContext } from '../../../contexts/ShopContext';
import { STOCK_STATUS, PRODUCT_TYPES } from '../../../const';
import ViewHelper from '../../../helpers/ViewHelper';
import ShopHelper from '../../../helpers/ShopHelper';
import ProductAddView from './ProductAddView';
import ProductQtyUpdateSec from './ProductQtyUpdateSec';
import OptionPopup from './OptionPopup';

export default function ProductView(props) {
  const {
    product,
    category,
    fnOpenProductDetailsPage,
    showDetailsPage = false,
    orderView = false,
    showStatus = false,
    showActionSection = true,
    gridSize = { xs: 6, sm: 3, md: 2, lg: 2 },
    compactView = false,
  } = props;

  const { addItemToCart, cart } = useContext(CartContext);
  const { shop } = useContext(ShopContext);

  const [selectedItem, setSelectedItem] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);

  const handleOpenOptions = (item) => {
    setSelectedItem(item);
    setPopupOpen(true);
  };

  const handleOptionSelect = (option) => {
    if (!selectedItem) return;

    const key = `${selectedItem.id}_${option.label.replace(/\s+/g, '_')}`;

    const itemToAdd = {
      ...selectedItem,
      cartKey: key,
      selectedOption: option,
      name: `${selectedItem.name} ${option.label}`,
      price: option.price,
      quantity_ratio: option.quantity_ratio,
    };

    addItemToCart(itemToAdd);
    setPopupOpen(false);
    setSelectedItem(null);
  };

  const openProductDetailsPage = () => {
    if (!showDetailsPage) return;
    fnOpenProductDetailsPage({ shop, category, product, cart });
  };

  const stockStatus = useMemo(() => {
    if (product.type === PRODUCT_TYPES.SERVICE) return null;
    if (product.stock <= 0) return STOCK_STATUS.sold_out;
    if (product.stock - product.stock_on_hold <= 0) return STOCK_STATUS.on_hold;
    return null;
  }, [product.type, product.stock, product.stock_on_hold]);

  const quantity = useMemo(() => {
    const cartProducts = Object.values(cart?.products || []);

    return cartProducts
      .filter((item) => item.product.id === product.id)
      .reduce((sum, item) => sum + (item.quantity || 0), 0);
  }, [cart, product.id]);

  return (
    <>
      <Grid item {...gridSize}>
        <div
          className={`${styles.productCard} ${compactView ? styles.cartProductCard : ''}`}
          onClick={openProductDetailsPage}
          style={{ backgroundColor: stockStatus ? stockStatus.backgroundColor : '' }}
        >
          <img
            className={`${styles.productImage} ${compactView ? styles.cartProductImage : ''}`}
            src={getProductImageSrc(product)}
            alt={product.name}
          />
          <div className={styles.productDetails}>
            <span className={styles.title}>{ViewHelper.toTitleCase(product.name)}</span>
            <div className={styles.bottomRow}>
              <div className={styles.rateSection}>
                {orderView ? (
                  <span className={styles.head}>
                    {ShopHelper.getShopCurrency(shop)} {product.rate * product.quantity} -{' '}
                    <span style={{ fontWeight: 400 }}> Qty:</span> {product.quantity}
                  </span>
                ) : (
                  <span className={styles.head}>
                    {ShopHelper.getShopCurrency(shop)} {product.price}
                  </span>
                )}
              </div>
              {showActionSection &&
                (showStatus ? (
                  stockStatus ? (
                    <span style={{ color: stockStatus.color }} className={styles.text}>
                      {stockStatus.label}
                    </span>
                  ) : (
                    <div className={styles.qtySection}>
                      {quantity > 0 ? (
                        <ProductQtyUpdateSec
                          product={product}
                          quantity={quantity}
                          handleOpenOptions={handleOpenOptions}
                          isCartPage={compactView}
                        />
                      ) : (
                        <ProductAddView product={product} handleOpenOptions={handleOpenOptions} />
                      )}
                    </div>
                  )
                ) : (
                  <div className={styles.qtySection}>
                    {quantity > 0 ? (
                      <ProductQtyUpdateSec
                        product={product}
                        quantity={quantity}
                        handleOpenOptions={handleOpenOptions}
                        isCartPage={compactView}
                      />
                    ) : (
                      <ProductAddView product={product} handleOpenOptions={handleOpenOptions} />
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </Grid>
      <OptionPopup
        open={popupOpen}
        onClose={() => setPopupOpen(false)}
        product={selectedItem}
        onSelectOption={handleOptionSelect}
      />
    </>
  );
}
